var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3044_1412)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.83997C0 0.735397 0.89543 -0.160034 2 -0.160034H22C23.1046 -0.160034 24 0.735396 24 1.83997V21.84C24 22.9445 23.1046 23.84 22 23.84H2C0.895431 23.84 0 22.9445 0 21.84V1.83997ZM22 1.83997L2 1.83997V21.84H22V1.83997Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2071 7.54707L13.5456 18.2086L9.54557 14.7086L1.70711 22.5471L0.292893 21.1329L9.45443 11.9713L13.4544 15.4713L22.7929 6.13286L24.2071 7.54707Z",
    fill: "#6C74B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8.83997C9.32843 8.83997 10 8.16839 10 7.33997C10 6.51154 9.32843 5.83997 8.5 5.83997C7.67157 5.83997 7 6.51154 7 7.33997C7 8.16839 7.67157 8.83997 8.5 8.83997ZM8.5 10.84C10.433 10.84 12 9.27296 12 7.33997C12 5.40697 10.433 3.83997 8.5 3.83997C6.567 3.83997 5 5.40697 5 7.33997C5 9.27296 6.567 10.84 8.5 10.84Z",
    fill: "#6C74B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3044_1412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIcon);
export default __webpack_public_path__ + "static/media/background-icon.a5d6a74a250df3876ec1fb4755579bdf.svg";
export { ForwardRef as ReactComponent };